export default {
  path: 'trips',
  name: 'trips',
  redirect: { name: 'trips.listing' },
  component: () => import(/* webpackChunkName: "trips" */ '@/views/Home/Trips'),
  children: [
    {
      path: '/',
      name: 'trips.listing',
      component: () =>
        import(/* webpackChunkName: "trips" */ '@/views/Home/Trips/TripList')
    },
    {
      path: 'create',
      name: 'trips.create',
      component: () =>
        import(/* webpackChunkName: "trips" */ '@/views/Home/Trips/CreateTrip')
    },
    {
      path: 'update/:id',
      name: 'trips.update',
      component: () =>
        import(/* webpackChunkName: "trips" */ '@/views/Home/Trips/UpdateTrip')
    }
  ]
}
